import { stripHtml } from "string-strip-html"

import { SearchResultModel } from "./searchResultModel"

export class LocationSearchResultModel extends SearchResultModel {
  getName(locale) {
    if (!this.document || !this.document.name || !this.document.name[locale]) {
      return ""
    }
    return this.document.name[locale]
  }

  getText(locale) {
    if (!this.document || !this.document.description || !this.document.description[locale]) return ""
    return stripHtml(this.document.description[locale] || "").result
  }

  getLinkUrl() {
    return "/munzing-group/munzing-worldwide/" + this.document.url || "#"
  }
}
